import _ from 'lodash'
import { RDnGaineRectangulaire_Type } from '@batical/types/src'
import { fetchGenericSorted, fetchGeneric } from './GenericQ'
const RDnGaineRectangulaire = require('../json/DnGaineEurovent_CarrreRctangulaire.json')

export function fetchDnGaineRectangulaireSorted(): Array<{ value: string; label: string }> {
  return fetchGenericSorted(RDnGaineRectangulaire)
}

export function fetchDnGaineRectangulaire(uuid: string): RDnGaineRectangulaire_Type {
  return fetchGeneric(RDnGaineRectangulaire, uuid)
}

export function fetchDnGaineRectangulaireDiametreInferieur(diam_int: number): RDnGaineRectangulaire_Type | null {
  const res = _.sortBy(
    RDnGaineRectangulaire.filter((item: RDnGaineRectangulaire_Type) => item.diam_int <= diam_int),
    ['diam_int']
  )

  if (res.length > 0) {
    return res[res.length - 1]
  }
  return null
}

export function fetchDnAround(selected_tube: string): Array<{ uuid: string; diam: number; grand: number; petite: number }> {
  let data: Array<{ uuid: string; diam: number; grand: number; petite: number }> = []
  //try another ugly thing if the number of data is small (the case here)
  const res = _.sortBy(RDnGaineRectangulaire, ['diam_int', 'grand_cote', 'petite_cote'])

  res.forEach((child: RDnGaineRectangulaire_Type) => {
    data.push({ uuid: child.uuid, diam: child.diam_int, grand: child.grand_cote, petite: child.petite_cote })
  })
  const index = data.findIndex(x => x.uuid === selected_tube)

  let startIndex = Math.max(index - 4, 0)
  let endIndex = Math.min(index + 5, data.length - 1)
  data = data.slice(startIndex, endIndex)

  return data
}
